<!--
同性同年齢の平均期待生存率
テキスト表示
-->
<template>
  <div
    class="text-wrapper"
  >{{ $t("aiPredictionReport.averageOfYourAgeForTheNext10Years", {genderConvert: genderConvert}) }}</div>
</template>

<script>
import VueTypes from "vue-types";

export default {
  props: {
    gender: VueTypes.number.isRequired
  },
  computed: {
    genderConvert: function() {
      if (this.gender === 1) {
        return this.$i18n.t("yourInformation.men");
      } else {
        return this.$i18n.t("yourInformation.women");
      }
    }
  }
};
</script>

<style scoped>
.text-wrapper {
  display: flex;
  justify-content: center;
  font-weight: bold;
}
</style>
